import { Reveal } from "../components/Reveal";
import { useFirm } from "../context/FirmContext";
import { ArrowUpRight } from "lucide-react";

const Contact = () => {
  const firm = useFirm();
  const phone = firm?.phone || "";
  const email = firm?.email || "anmol@attryassociates.in";

  return (
    <div data-testid="contact-page">
      <section className="border-b border-[var(--rule)] py-20 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-3">
            <p className="text-[11px] tracking-[0.32em] uppercase text-neutral-500">— Vol. 05 · Contact</p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-9">
            <h1 className="font-serif text-5xl sm:text-7xl lg:text-[8.5vw] font-light tracking-tighter leading-[0.92]">
              Speak with the <span className="italic">practice.</span>
            </h1>
            <p className="font-serif text-xl lg:text-2xl text-neutral-700 mt-10 max-w-3xl leading-snug">
              We don't operate a contact form. We answer email and pick up the phone — usually
              within the working day, always personally.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 lg:py-32 border-b border-[var(--rule)]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="border-t border-neutral-900">
            <Reveal>
              <a
                href={`mailto:${email}`}
                data-testid="contact-email-link"
                className="block group border-b border-neutral-900 py-10 lg:py-14 transition-colors hover:bg-neutral-950 hover:text-neutral-50"
              >
                <div className="grid grid-cols-12 gap-6 items-baseline">
                  <span className="col-span-2 lg:col-span-1 marker text-3xl lg:text-5xl text-neutral-400">01</span>
                  <span className="col-span-10 lg:col-span-3 text-[11px] tracking-[0.28em] uppercase text-neutral-500 group-hover:text-neutral-400">Email — preferred</span>
                  <span className="col-span-12 lg:col-span-7 font-serif text-3xl lg:text-6xl font-light tracking-tighter leading-none break-all">
                    {email}
                  </span>
                  <ArrowUpRight size={28} className="col-span-12 lg:col-span-1 justify-self-end transition-transform duration-500 group-hover:rotate-45" />
                </div>
              </a>
            </Reveal>

            {phone && (
              <Reveal delay={0.1}>
                <a
                  href={`tel:${phone.replace(/\s/g, "")}`}
                  data-testid="contact-phone-link"
                  className="block group border-b border-neutral-900 py-10 lg:py-14 transition-colors hover:bg-neutral-950 hover:text-neutral-50"
                >
                  <div className="grid grid-cols-12 gap-6 items-baseline">
                    <span className="col-span-2 lg:col-span-1 marker text-3xl lg:text-5xl text-neutral-400">02</span>
                    <span className="col-span-10 lg:col-span-3 text-[11px] tracking-[0.28em] uppercase text-neutral-500 group-hover:text-neutral-400">Telephone</span>
                    <span className="col-span-12 lg:col-span-7 font-serif text-3xl lg:text-6xl font-light tracking-tighter leading-none">
                      {phone}
                    </span>
                    <ArrowUpRight size={28} className="col-span-12 lg:col-span-1 justify-self-end transition-transform duration-500 group-hover:rotate-45" />
                  </div>
                </a>
              </Reveal>
            )}

            <Reveal delay={0.2}>
              <div className="border-b border-neutral-900 py-10 lg:py-14" data-testid="contact-office">
                <div className="grid grid-cols-12 gap-6 items-baseline">
                  <span className="col-span-2 lg:col-span-1 marker text-3xl lg:text-5xl text-neutral-400">03</span>
                  <span className="col-span-10 lg:col-span-3 text-[11px] tracking-[0.28em] uppercase text-neutral-500">Office</span>
                  <span className="col-span-12 lg:col-span-8 font-serif text-3xl lg:text-5xl font-light tracking-tight leading-tight">
                    {firm?.address || "SCO 90-91-92, Sector 8C, Chandigarh — 160009"}
                    <br />
                    <span className="italic text-neutral-500">{firm?.city || "Chandigarh, India"}</span>
                  </span>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.3}>
              <div className="py-10 lg:py-14" data-testid="contact-hours">
                <div className="grid grid-cols-12 gap-6 items-baseline">
                  <span className="col-span-2 lg:col-span-1 marker text-3xl lg:text-5xl text-neutral-400">04</span>
                  <span className="col-span-10 lg:col-span-3 text-[11px] tracking-[0.28em] uppercase text-neutral-500">Hours</span>
                  <span className="col-span-12 lg:col-span-8 font-serif text-2xl lg:text-3xl font-light tracking-tight leading-snug">
                    Monday — Friday · 10:00 to 19:00 IST
                    <br />
                    <span className="italic text-neutral-500">Saturdays by appointment</span>
                  </span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
